import React, { useState } from "react";
import AddonModal from "./AddonModal";

const RequestAddon = () => {
    const [showModal, setShowModal] = useState(false);

    const handleModal = () => {
        setShowModal(true);
    };

    return (
        <>
            <button
                onClick={handleModal}
                className="flex items-center cursor-pointer p-2 font-inter 
                font-medium text-sm leading-5 text-ec-primary"
            >
                Request Addon
            </button>
            {showModal && <AddonModal setShowModal={setShowModal} />}
        </>
    );
};

export default RequestAddon;